/**
 * Stringify object into query params and sort them by name
 * (identical to query-string.stringify)
 * @param {object} queryParametersObject
 * @returns {string} parsed object into format like key1=value1&key2=value2
 */
export const stringify = (queryParametersObject) => {
  if (!queryParametersObject || typeof queryParametersObject !== 'object') return '';

  return Object
    .entries(queryParametersObject)
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');
};
